import { QRCodeProps } from './QRCode.types';
import { SQRCode } from './QRCode.styles';

export const QRCode = (props: QRCodeProps) => {
  return <SQRCode {...props} />;
};
